import ServiceDetails from './ServiceDetails';

export default ServiceDetails;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/ServiceDetails/index.js